// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_eXa","cls2":"LettersModal-cls2_bhl LettersModal-cls1_eXa"};